import { graphql } from 'react-relay';

/**
 * Added item to initial query to be able to pull
 * redirectPdp_item on server to determine if we need to redirect.
 * Do not add other framments to item in this query
 */

export const pdpRespRootQuery = graphql`
    query pdpRespRootQuery(
        $newAndCustomSplitTest: Boolean
        $isClient: Boolean!
        $itemId: String!
        $userId: String = ""
        $fetchUser: Boolean!
        $relationshipUserIds: [String]!
        $favoritePages: [String]
        $fetchFavorites: Boolean!
        $isTrade: Boolean!
    ) {
        viewer {
            ...PdpRespLayout_viewer
            ...prepareLanguageAnnotations_viewer
            item(itemId: $itemId) {
                ...redirectPdp_item
            }
        }
    }
`;

export const pdpRespVariables = {
    isClient: false,
    itemId: null,
    newAndCustomSplitTest: false,
    selectedItemIds: [],
    userId: '',
    userIds: [],
    fetchUser: false,
    loadPortfolioData: false,
    relationshipUserIds: [],
    favoritePages: null,
    fetchFavorites: false,
    isTrade: false,
};

export default pdpRespRootQuery;
